import React    from 'react';
import Terms    from '../../../global/globalTermsOfUse';
import * as GV  from '../../../global/globalVariables';

function TermsOfUsePasswordWallet() {
    
    return (
      <>
      <Terms name={GV.APP_PASSWORD_WALLET}></Terms>
      </>
    )
}

export default TermsOfUsePasswordWallet;